import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
export function Hero() {
  return <>
      <section id="accueil" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-secondary-dark via-secondary to-secondary-dark" data-id="element-141">
        <video className="absolute top-0 left-0 w-full h-full object-cover opacity-20" autoPlay muted loop playsInline data-id="element-142">
          <source src="https://uploadnow.io/files/McrZP8s" type="video/mp4" data-id="element-143" />
        </video>

        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden" data-id="element-144">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse" data-id="element-145"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-146"></div>
        </div>

        <div className="w-full max-w-[1200px] mx-auto px-6 pt-32 pb-20 relative z-10" data-id="element-147">
          <div className="max-w-[900px]" data-id="element-148">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 backdrop-blur-sm text-sm font-medium text-white mb-8 animate-fade-in-up" data-id="element-149">
              <span className="w-2 h-2 rounded-full bg-primary animate-pulse" data-id="element-150"></span>
              Leader du courtage en Europe
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8 tracking-tight text-white" data-id="element-151">
              Optimisez votre logistique{' '}
              <span className="relative inline-block" data-id="element-152">
                <span className="text-primary" data-id="element-153">sans contraintes</span>
                <svg className="absolute -bottom-2 left-0 w-full" height="12" viewBox="0 0 300 12" fill="none" data-id="element-154">
                  <path d="M2 10C50 5 100 2 150 5C200 8 250 10 298 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" className="text-primary/50" data-id="element-155" />
                </svg>
              </span>
            </h1>

            <p className="text-xl md:text-2xl mb-12 text-white leading-relaxed max-w-[700px] font-light" data-id="element-156">
              Accédez à plus de 500 fournisseurs qualifiés. Solutions flexibles
              pour les professionnels de la logistique, de l'agroalimentaire et
              de la distribution.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-157">
              <a href="#contact" className="group inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-primary to-primary-dark text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-primary/30 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden" data-id="element-158">
                <span className="relative z-10 flex items-center gap-2" data-id="element-159">
                  Demander un devis
                  <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-160" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-primary-dark to-primary opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-161"></div>
              </a>
              <a href="#gamme" className="group inline-flex items-center justify-center px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white rounded-full font-semibold text-lg hover:bg-white/20 hover:-translate-y-1 transition-all duration-300" data-id="element-162">
                Découvrir notre gamme
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 md:gap-8" data-id="element-163">
              {[{
              icon: '🏢',
              text: '+500 Fournisseurs'
            }, {
              icon: '🚚',
              text: 'Livraison 48/72h'
            }, {
              icon: '✓',
              text: 'Sans engagement'
            }].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white/10 backdrop-blur-sm px-5 py-3 rounded-full border border-white/20" data-id="element-164">
                  <span className="text-xl" data-id="element-165">{item.icon}</span>
                  <span className="text-sm font-medium text-white" data-id="element-166">
                    {item.text}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        {/* Decorative wave */}
        <div className="absolute bottom-0 left-0 w-full" data-id="element-167">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-168">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" data-id="element-169" />
          </svg>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-24 bg-white" data-id="element-170">
        <div className="w-full max-w-[1200px] mx-auto px-6" data-id="element-171">
          <div className="text-center mb-12" data-id="element-172">
            <span className="text-primary font-semibold tracking-wider uppercase text-sm" data-id="element-173">
              Découvrez notre expertise
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-secondary-dark mt-3 mb-6" data-id="element-174">
              Comment nous révolutionnons la logistique
            </h2>
          </div>

          <div className="relative rounded-3xl overflow-hidden shadow-2xl group cursor-pointer bg-gradient-to-br from-gray-100 to-gray-200" data-id="element-175">
            <div className="aspect-video relative" data-id="element-176">
              <video className="w-full h-full object-cover" poster="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&h=675&fit=crop" controls data-id="element-177">
                <source src="https://uploadnow.io/files/McrZP8s" type="video/mp4" data-id="element-178" />
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-secondary-dark/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-179"></div>
            </div>
          </div>
        </div>
      </section>
    </>;
}